<template lang="pug">
  .box-line-dot(@click="click()")
    vm-icon.icon(icon="plus-circle" color="grey" size="1rem")
    span.blue Click
    span  para
    span {{ text }}
</template>

<script>
export default {
  name: 'ButtonLineDot',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data: () => ({

  }),
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
$width: 25px;
.box-line-dot {
  width: 100%;
  height: 65px;
  border-radius: 10px;
  padding: 25px 20px;
  border: 1px dashed rgb(151, 151, 151);
  text-align: center;
  align-items: center;
  font-size: 14px;
  color: rgb(151, 151, 151);
  cursor: pointer;
  margin: 20px 0px 10px 0px;
}
.icon {
  margin: 7px 10px;
}
.blue {
  color: #156eb9;
}
</style>
